import { render, staticRenderFns } from "./AdmissionTicket.vue?vue&type=template&id=526f06d0&scoped=true&"
import script from "./AdmissionTicket.vue?vue&type=script&lang=js&"
export * from "./AdmissionTicket.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionTicket.vue?vue&type=style&index=0&id=526f06d0&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526f06d0",
  null
  
)

export default component.exports